import { TMap } from '@client/new/helpers/types';
import { WorkoutType } from './workouts/workouts.domain';
import { StatusTagProps } from '@client/new/components/StatusTag/StatusTag';
import {
  GetCollectionPageDataQuery,
  WorkoutTiny as GqlWorkoutTiny,
} from 'generated/graphql';
import { LiteProgramType } from './mappers';

export type WorkoutTiny = Pick<
  GqlWorkoutTiny,
  | 'id'
  | 'statsRatingAverage'
  | 'statsComments'
  | 'statsBegins'
  | 'statsCompletions'
>;

export type LiteInfluencer = {
  influencerId: number;
  isLive: boolean;
  hasPaymentMethod: boolean;
  landingPageBuilderUrl: string;
  addWorkoutsUrl: string;
  isInfluencerReadyToPublish: boolean;
};

export type LiteProgram = {
  programId: number;
  programType: SalesType;
  categoryType: LiteProgramType;
  workouts: WorkoutTiny[];
  salesPageUrl: string;
  hasSalesPageConfig: boolean;
  price: string;
  discountedPrice: string | null;
  tags: Array<StatusTagProps>;
  programState: 'not-publish-ready' | 'publish-ready' | 'published';
  title: string;
  subtitle: string;
  thumbnailUrl: string;
  index?: number;
  deeplinkUrl?: string;
  accessType: string;
  migrationBundleId: number | null;
};

export const salesTypeValues = ['otp', 'subscription'] as const;
export type SalesType = (typeof salesTypeValues)[number];

export const discountTypeValues = ['Percentage', 'FixedAmount'] as const;
export type DiscountType = (typeof discountTypeValues)[number];

export const subscriptionTypeValues = ['annual', 'monthly'] as const;
export type SubscriptionType = (typeof subscriptionTypeValues)[number];

export type WorkoutsTabHash = `workouts-${WorkoutType}`;

export type ProgramTabHash =
  | WorkoutsTabHash
  | 'about'
  | 'pricing'
  | 'sales-page'
  | 'page-builder'
  | 'challenges'
  | 'pricing-packages';

export const allTabs: TMap<ProgramTabHash, string> = {
  'workouts-published': 'Workouts',
  'workouts-draft': 'Workouts',
  'workouts-archived': 'Workouts',
  'workouts-scheduled': 'Workouts',
  challenges: 'Challenges',
  about: 'About',
  pricing: 'Price',
  'pricing-packages': 'Price & packages',
  'sales-page': 'Landing Page',
  'page-builder': 'Landing Page Builder',
};

export const workoutTabToType: TMap<WorkoutsTabHash, WorkoutType> = {
  'workouts-published': 'published',
  'workouts-draft': 'draft',
  'workouts-archived': 'archived',
  'workouts-scheduled': 'scheduled',
};

export const workoutTypeToTab: TMap<WorkoutType, WorkoutsTabHash> = {
  published: 'workouts-published',
  draft: 'workouts-draft',
  archived: 'workouts-archived',
  scheduled: 'workouts-scheduled',
};

export type RawCollection = GetCollectionPageDataQuery['collection'];

export type Price = {
  price: number;
  playbookFee?: number;
  discountedPrice?: number;
  discountPercent?: number;
};
